import { all } from 'redux-saga/effects';
import getMailSaga from './mail';
import getMailsSaga from './mails';
import resendMailSaga from './resend';

export default function* mailSaga() {
  yield all([getMailsSaga(), getMailSaga(), resendMailSaga()]);
}
